import Global from '../styles/pages/Global.module.scss'
import BecomeLesseeForm from '../components/form/BecomeLesseeForm'
import Lessee from '../styles/pages/BecomeLessee.module.scss'
import LesseeImage from '../shared/images/lessee.svg'
import { RootState } from '../store/GlobalStore'
import { useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const BecomeLessee: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const navigate = useNavigate()

    useEffect(() => {
        if (authState.user) {
            navigate('/mon-compte')
        }
    }, [authState.user, navigate])
    return (
        <div className={Global.Pages}>
            <div className={Lessee.mainPicture}>
                <img src={LesseeImage} />
                <div className={Lessee.borderBackground}></div>
            </div>
            <div className={Lessee.mainTitle}>
                <h2>Devenir locataire Farmer Country</h2>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing,
                    <u>avantages à devenir locataire Farmer Country</u>
                </p>
            </div>
            <BecomeLesseeForm />
        </div>
    )
}

export default BecomeLessee
